import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as globals from '@reusable/services/globals';
import { map } from 'rxjs/operators';

@Injectable()
export class TeamCorePartsService {
  responseData: any;
  handleError: any;

  constructor(private router: Router, private gtn: globals.GetTokenNow, private httpClient: HttpClient) {}

  viewCorePart(corePartId) {
    return this.httpClient.get(`${globals.domain}/core/parts/${corePartId}/view`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  editCorePart(corePartId) {
    return this.httpClient.get(`${globals.domain}/core/parts/${corePartId}/edit/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  updateCorePart(corePartId, body) {
    return this.httpClient
      .put(`${globals.domain}/core/parts/${corePartId}/update/`, JSON.stringify(body), this.gtn.getHeaders())
      .pipe(map(res => res as any));
  }
  // requestId ,
  addCorePart(body) {
    return this.httpClient.post(`${globals.domain}/core/parts/add/`, JSON.stringify(body), this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  addCorePartWithEcommerceCategory(body) {
    return this.httpClient.post(`${globals.domain}/core/parts/add-with-e-commerce-category/`, JSON.stringify(body), this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  removeCorePart(corePartId) {
    return this.httpClient.delete(`${globals.domain}/core/parts/${corePartId}/remove/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  restoreCorePart(corePartId) {
    return this.httpClient.put(`${globals.domain}/core/parts/${corePartId}/restore/`, {}, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  rearrangeCorePart(body) {
    return this.httpClient.put(`${globals.domain}/core/parts/rearrange/`, JSON.stringify(body), this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  listCoreParts(sort, records, pageNumber, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/core/parts/list/sortBy-${sort}/${records}/${pageNumber}/`, updateQueries)
      .pipe(map(res => res as any));
  }
  searchCoreParts(sort, records, pageNumber, keyword, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/core/parts/search/sortBy-${sort}/${records}/${pageNumber}/${keyword}`, updateQueries)
      .pipe(map(res => res as any));
  }
}